
import { defineComponent } from 'vue';
import { GrouperLayoutMode } from 'src/services/IodineGrouperService';
import { useLayoutStore } from 'stores/layout-store';
import { useGrouperStore } from 'stores/grouper-store';
import debounce from 'lodash.debounce';
import { useQuasar } from 'quasar';

// TODO remove when we put back in the error message
// eslint-disable-next-line 
let $q = useQuasar();

// I'm cool with this being an any
// eslint-disable-next-line 
const errorHandler = (event: any) => {

  // As of now we do not want errors from main app to be propagated to the message
  if (event?.reason?.stack?.includes('Bundle.js')
      || event?.error?.stack?.includes('Bundle.js')) {
    console.error(event);
  } else {
    let message = event.message;
    if (!message) {
      if (!event.reason.message) {
        message = event.reason;
      } else {
        message = event.reason.message;
      }
    }
    const textContent = `${event.type}: ${message}`;
    printErrorMessage(textContent);

    console.error(event);
  }
};

// TODO remove when we put back in the error message
// eslint-disable-next-line
function printErrorMessage(message: string) {
  /*
  $q.dialog({
    color: 'white',
    html: true,
    title: 'Sorry something went wrong.',
    message: `<div style="padding: 10px; word-break: break-all;">Error: ${message}</div>`,
    ok: {
      class: 'dialog-button',
      label: 'Close'
    },
  });
  */
}

export default defineComponent({
  name: 'App',
    computed: {
      consolidated: () => {
          return useLayoutStore().layoutMode != GrouperLayoutMode.fullScreen;
      },
      embeddedResourcesOpen: () => {
        return useLayoutStore().isResourcesSelected;
      }
    },
    unmounted() {
      useGrouperStore().$reset();
      useLayoutStore().$reset();

      window.removeEventListener('error', errorHandler);
      window.removeEventListener('unhandledrejection', errorHandler);
    },
    mounted() {
      $q = useQuasar();
      window.addEventListener('error', errorHandler);
      window.addEventListener('unhandledrejection', errorHandler);

      useGrouperStore().$onMount();
      useLayoutStore().$onMount();
    }
});

// eslint-disable-next-line
const _ = (window as any).ResizeObserver;
// eslint-disable-next-line
(window as any). ResizeObserver = class ResizeObserver extends _ {
    constructor(callback: (...args: unknown[]) => void) {
        callback = debounce(callback, 20);
        super(callback);
    }
};
